import {
  LIVE_MODE,
  V2_COMPARTMENT_LTM,
  V2_COMPARTMENT_SKIP_LTM,
} from './constants';
import type {V2BaseToken} from './types';

export default function getLiveModeFromToken(token: V2BaseToken) {
  if (token[V2_COMPARTMENT_LTM] && token[V2_COMPARTMENT_SKIP_LTM]) {
    return 'FORCE_LIVE' as const;
  }

  return token[LIVE_MODE];
}
